export enum VicPageVariant {
    READ,
    CREATE,
    CLONE,
}
